import React, { useEffect, useState } from "react";
import { Box, Grid, } from "@mui/material";
import AccountProfile from "./AccountProfile";
import Sidebar from "../../../components/sideNav";
import Header from "../../../components/header";
import ParentWrapper from "../../../components/ParentWrapper";

function Account() {
  return (
    // <Box>
    //   <Box>
    //     <Box
    //       sx={{
    //         ml: {
    //           xs: "0px",
    //           md: "230px",
    //         },
    //         p:3
    //       }}
    //     >

    <ParentWrapper>


      <Box
        sx={{
          display: {
            xs: "none",
            md: "initial",
          },
        }}
      >
        <Header title={"Account Details"} />
      </Box>
      <Grid container sx={{ mb: 2, p: 3 }}>
        {/* Dashboard Title */}
        <AccountProfile />
      </Grid>

    </ParentWrapper>

    //     </Box>
    //   </Box>
    // </Box>
  );
}

export default Account;
